import _isObject from 'lodash/isObject';

export const cleanObject = (object) => {
  for (const key in object) {
    if (object[key] === '') {
      delete object[key];
    }
    if (_isObject(object[key])) {
      cleanObject(object[key]);
    } else if (typeof object[key] === 'undefined' || object[key] === null) {
      delete object[key];
    }
    if (Array.isArray(object[key])) {
      object[key] = object[key].filter((field) => Object.keys(field).length);
    }
  }
  return object;
};
